import { cls } from "../components/Utility";
import { useState } from "react";
import Call from "../components/Call";
import DesktopWa from "../components/DesktopWa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Helmet } from "react-helmet";
import auth1 from "../assets/pictures/contact/connect_44.webp";

export default function Contact() {
  const [result, setResult] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    event: "",
    happeningDate: "",
    countryCode: "+91",
    phoneNumber: "",
    city: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleDateChange = (date) => {
    setFormData((prevData) => ({
      ...prevData,
      happeningDate: date,
    }));
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    setShowMessage(true);

    const formDataToSend = new FormData();
    for (const key in formData) {
      formDataToSend.append(key, formData[key]);
    }
    formDataToSend.append("access_key", "bbfedd98-01de-4af0-8bda-388396a1dff8");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formDataToSend,
      });
      const data = await response.json();

      if (data.success) {
        setResult("Form Submitted Successfully");
        setFormData({
          name: "",
          event: "",
          countryCode: "+91",
          phoneNumber: "",
          city: "",
          message: "",
        });
      } else {
        console.log("Error", data);
        setResult(data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      setResult("An error occurred. Please try again later.");
    }

    setTimeout(() => {
      setShowMessage(false);
    }, 2000);
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Stories by RG",
              "url": "https://www.storiesbyrg.com/contact",
              "description": "Looking for the best wedding photography why to wait contact us soon"
            }
          `}
        </script>
      </Helmet>

      <div className={cls("hidden", "xl:flex")}>
        <div className="relative w-full h-screen overflow-hidden">
          <div className="w-full h-[500px]">
            <img src={auth1} />
          </div>
        </div>
      </div>

      <div className={cls("flex overflow-x-hidden", "xl:hidden")}>
        <div className="relative w-full overflow-hidden">
          <img src={auth1} className="w-full h-[500px] object-cover" />
        </div>
      </div>
      <p className="xl:mt-[50px] text-center text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] mt-[30px] pl-[20px] pr-[20px]">
        Please fill in the form and provide all the essential details to help us
        to create the best and accurate quote.
      </p>
      <p className="mt-[10px] text-center  text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px]  pl-[20px] pr-[20px]">
        we will try to reach out to you with in 24 hours else give us a call on
        the number below to get an instant reply. If it's a peak moment of the
        event.
      </p>
      <p className="text-center font-bold text-black xl:text-[30px] text-[25px] xl:pl-[380px] xl:pr-[380px] xl:mt-[30px] mt-[30px] font-[Headings] tracking-wider">
        CONTACT US
      </p>

      <p className="mt-[30px] text-center  text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px]  pl-[20px] pr-[20px] ">
        Mail: hello@storiesbyrg.com
      </p>
      <p className="mt-[10px] text-center text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px]  pl-[20px] pr-[20px]">
        Call: +91 9980685056
      </p>
      <p className="text-center font-bold text-black xl:text-[30px] text-[25px] xl:pl-[380px] xl:pr-[380px] xl:mt-[50px] mt-[30px] font-[Headings] tracking-wider">
        MEET US
      </p>

      <p className="mt-[10px] text-center text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px]  pl-[20px] pr-[20px]">
        Head office: First Floor, No: 12/1, 1, Palace Cross Rd, Military
        Compound, Jayamahal, Bengaluru, Karnataka 560020
      </p>

      <p className="mt-[10px] text-center text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px]  pl-[20px] pr-[20px]">
        Branch office: 92 Huda Heights road, Lane No. 12, MLA Colony, Banjara
        Hills, Hyderabad, Telangana 500028
      </p>

      <div className={cls("pl-[15px] pr-[15px]")}>
        <div>
          <p className="capitalize xl:text-[30px] text-[25px] font-bold font-[Headings] tracking-wider text-black text-center xl:mt-[50px] md:mt-[70px] mt-[40px]">
            SERVICES INQUIRY FORM
          </p>
          <p className="mt-[40px] text-center text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px]  pl-[20px] pr-[20px]">
            Thank you for your interest in our photography services! Please fill
            out the form below, and we will get back to you as soon as possible.
          </p>
          <div className="flex justify-center">
            <div className="mt-[50px] rounded-2xl xl:px-[80px] xl:py-[30px] px-[30px] py-[25px] bg-[#edecec] border-[1px] border-black mb-[30px] xl:w-[600px] xl:h-[550px] max-w-full h-[550px] md:w-full md:h-full ">
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col gap-[20px]">
                  <input
                    type="text"
                    name="name"
                    autoComplete="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="border-b-[1px] border-black rounded-xl w-full p-[10px] outline-none placeholder:text-black text-[14px] font-[description1]"
                    placeholder="Name*"
                  />

                  <div className="flex gap-[20px] font-[description1]">
                    <label htmlFor="countryCode" className="sr-only">
                      Country Code:
                    </label>
                    <select
                      id="countryCode"
                      name="countryCode"
                      autoComplete="country code"
                      value={formData.countryCode}
                      onChange={handleChange}
                      className="border-b-[1px] border-black rounded-xl p-[10px] outline-none placeholder:text-black text-[14px] w-[100px]"
                    >
                      <option value="+91">+91</option>
                      <option value="+1">+1</option>
                      <option value="+44">+44</option>
                      <option value="+61">+61</option>
                      <option value="+86">+86</option>
                      <option value="+33">+33</option>
                      <option value="+49">+49</option>
                      <option value="+81">+81</option>
                      <option value="+7">+7</option>
                      <option value="+82">+82</option>
                    </select>

                    <input
                      type="tel"
                      autoComplete="phone number"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                      pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                      className="border-b-[1px] border-black rounded-xl p-[10px] outline-none placeholder:text-black text-[14px] w-full"
                      placeholder="Your Number*"
                    />
                  </div>
                  <input
                    type="text"
                    name="event"
                    autoComplete="event"
                    value={formData.event}
                    onChange={handleChange}
                    className="border-b-[1px] border-black rounded-xl w-full p-[10px] outline-none placeholder:text-black text-[14px] font-[description1]"
                    placeholder="Event"
                  />
                  <DatePicker
                    selected={formData.happeningDate}
                    onChange={handleDateChange}
                    className="border-b-[1px] border-black rounded-xl p-[10px] outline-none placeholder:text-black text-[14px] w-full font-[description1] font-normal"
                    dateFormat="dd/MM/yyyy"
                    id="happeningDate"
                    name="happeningDate"
                    autoComplete="happeningDate"
                    placeholderText="Happening Date"
                  />
                  <input
                    type="text"
                    name="city"
                    autoComplete="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    className="border-b-[1px] border-black rounded-xl  w-full p-[10px] outline-none placeholder:text-black text-[14px] font-[description1]"
                    placeholder="City*"
                  />
                  <textarea
                    name="message"
                    autoComplete="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className="border-b-[1px] border-black rounded-xl w-full p-[10px] outline-none placeholder:text-black text-[14px] font-[description1]"
                    placeholder="Message"
                  />
                </div>

                <div className="flex justify-center items-center mt-[30px]">
                  <button
                    type="submit"
                    className="bg-black text-white font-[description1] pl-[15px] pr-[15px] text-center mt-[20px] w-[250px] pt-[10px] pb-[10px] text-[14px] rounded-none "
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
            {showMessage && (
              <div className="w-full flex justify-center items-center text-[#A4a4a4] font-semibold text-[14px] font-[description1]">
                Form submitted successfully...
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
